module.exports = __webpack_public_path__ + "static/media/abrir-menu-mobile_custom.db5a6100.svg";